import { useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import AdminModal from '../../../../components/AdminModal';
import useToast from '../../../../customHooks/useToast';
import { ADD_MEMBERS_TO_ROLE } from '../../../../graphql/admin_mutations';
import CircleCheckIcon from '../../../../svgs/CircleCheckIcon';
import Styles from './AddMemberModal.module.scss';

interface IAddMemberModal{
  selectedMemberIds:any;
  onClose:any;
  refetch:any;
  activeRoleId:any;
  newAddedMembers:any;
}
const AddMemberModal = ({
  selectedMemberIds, onClose, refetch, activeRoleId, newAddedMembers,
}:IAddMemberModal) => {
  const Toast = useToast();
  const [addMemberToRole, { loading: addMemberToRoleLoading }] = useMutation<
  { addMembersToRole: any },
  any
  >(ADD_MEMBERS_TO_ROLE);

  const [isSuccessful, setIsSuccessful] = useState(false);

  const [updatedMemberNames, setUpdatedMemberNames] = useState(null);

  const getSelectedMembers = (data:any) => {
    const memberNames = data.map((member:any) => `${member?.firstName} ${member?.lastName}`);

    const lastRoles = memberNames?.slice(-2);

    const otherRoleNames = memberNames.slice(0, -2).join(', ');

    const result = otherRoleNames + (otherRoleNames ? ', ' : '') + lastRoles.join(' & ');

    setUpdatedMemberNames(result);
  };

  useEffect(() => {
    if (newAddedMembers) {
      getSelectedMembers(newAddedMembers);
    }
  }, [newAddedMembers]);

  const handleAddMembers = async () => {
    const data = {
      roleId: activeRoleId?.id,
      userIds: selectedMemberIds?.map((list:any) => list?.id),
    };

    if (!addMemberToRoleLoading) {
      try {
        const res = await addMemberToRole({
          variables: data,
        });

        if (res?.data?.addMembersToRole && res?.data?.addMembersToRole?.status === 200) {
          setIsSuccessful(true);
          refetch?.();
        } else {
          Toast.error(res?.data?.addMembersToRole?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={isSuccessful ? 'Member Added!' : `Are you sure you want to add this member to ${activeRoleId?.name}?`}
        subText={isSuccessful ? `${updatedMemberNames} has been added to ${activeRoleId?.name} successfully.` : 'By clicking on “Add”, you are accepting to add this member by making it accessible in the system. If you are not sure, please cancel.'}
        actionBtnName="Yes, Add Member"
        handleModalAction={handleAddMembers}
        topIcon={<div className={Styles.wrapper__icon}><CircleCheckIcon /></div>}
        isShow
        isActionBtnDisabled={addMemberToRoleLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={addMemberToRoleLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__confirmMemberBtn}
      />
    </div>
  );
};

export default AddMemberModal;
